export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12203.8e2a5020.jpg";